import React, { useRef, useState, useEffect } from "react";
import { convertStringToArray } from "../../../../Utils/utils";
import Viewer from "react-viewer";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import { useTableResponsive } from "../../../../hooks/useTableResponsive";
import PdfZipItem from "../../../../components/PdfZipItem";
import { useDispatch } from "react-redux";
import { setCsrActiveTab } from "../../../../redux/slice/sliceHome";

const OurApproach = ({ data, data2 }) => {
  console.log(data);
  const { getText } = useLanguageTranslation();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: `${process.env.REACT_APP_IMAGE_URL}/${img.file_path}`,
        alt: img.title,
      }))
    );
    setActiveIndex(index);
    setVisible(true);
  };

  // convert string into pdf array
  const pdfArray = convertStringToArray(data?.field_download);

  // convert string into images array
  const imagesArray = convertStringToArray(data?.field_events_image);

  // customize array for light box

  useTableResponsive(data);

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const anchors = container.querySelectorAll("a");

    const handleClick = (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 140,
        behavior: "smooth", // 👈 smooth scroll to top
      });
    };

    anchors.forEach((anchor) => {
      anchor.addEventListener("click", handleClick);
    });

    // 🧹 Cleanup event listeners on unmount
    return () => {
      anchors.forEach((anchor) => {
        anchor.removeEventListener("click", handleClick);
      });
    };
  }, [data2]);

  return (
    <>
      {/* <!--content section start here--> */}
      <div className="mt-4">
        <h2 className="title3">{data?.title}</h2>
      </div>
      <div className="table-responsive">
        <table className="table table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Download", "डाउनलोड")}</th>
            </tr>
          </thead>
          <tbody>
            {pdfArray.map((item, index) => (
              <tr key={index}>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Description", "विवरण")}>{item.title}</td>
                <td data-key={getText("Download", "डाउनलोड")}>
                  <PdfZipItem filePath={item?.file_path} />
                  {/* <a
                    href={`${process.env.REACT_APP_IMAGE_URL}/${item?.file_path}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="pdf-icon">
                      <img
                        src="./images/pdf-icon.png"
                        alt=""
                        className="mr-2"
                      />
                    </div>
                  </a> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        ref={containerRef}
        dangerouslySetInnerHTML={{ __html: data2?.body }}
      ></div>
      {/* <div className="mt-4">
        <h3 className="t-heading">Our Objectives /Our Focus area</h3>
        <p>
          NEEPCO operates in entire geographies across the North Eastern region
          of the country and CSR initiatives / programmes are implemented at
          neighborhood of NEEPCO's operating stations, projects under execution
          and other establishments with due consultation and participation of
          stakeholders according to their specific needs guided by baseline
          survey assessment. The focus of Company's CSR policy remains steadfast
          on the issue of Community Development in the field of education,
          health, infrastructure development, capacity building and other
          general well-being. As a responsible corporate citizen, NEEPCO is
          committed for sustainable development of the society and improvement
          the quality of life of the communities it serves. To undertake
          community development in the neighborhood of operating stations,
          projects under execution and other establishments of the Corporation
          with particular focus on education, health, infrastructure development
          and other community needs.
        </p>
        <p>
          To undertake community development in the neighborhood of operating
          stations, projects under execution and other establishments of the
          Corporation with particular focus on education, health, infrastructure
          development and other community needs. Robust mechanism has been
          adopted for identification of social projects in consultation with the
          stakeholders. Projects are implemented through in house resources or
          other agencies viz. Govt. agency /local panchayat / NGO’s etc.
        </p>

        <div className="t-heading">About us</div>
        <p>
          The North Eastern Electric Power Corporation (NEEPCO) Ltd, a schedule
          A- Mini Ratna (Category-I) CPSE was formed in April, 1976 as a
          Government of India Enterprise with the objective to plan, promote,
          organize, investigate, survey, design, acquire, construct, generate,
          operate and maintain power stations in the entire North Eastern
          Region. The Corporation, after 44 years of successful operation, is a
          premier power utility of the North East, with an installed capacity of
          2057 MW comprising of hydroelectric, natural gas based/ thermal power
          stations as well as Solar and has significantly contributed towards
          improvement of power scenario in the North East Region. With concerted
          &amp; relentless efforts, it has become the most dependable power
          utility of NE Region of the country till date.
        </p>
        <div className="t-heading">CSR Initiatives</div>
        <p>
          Since its inception, NEEPCO has always accorded top priority towards
          all round development of the people residing in and around its
          operational areas. As a responsible corporate entity NEEPCO has
          undertaken various community development activities particularly in
          the field of education, health, infrastructure development and other
          community needs.
        </p>
        <p>
          In accordance with the provisions of the Companies Act, 2013, the
          Companies (Corporate Social Responsibility Policy) Rules, 2014, MCA
          General Circular no. 21/2014 dated 18.06.2014 and revised DPE
          guidelines, the NEEPCO’s CSR policy has been approved by the Board of
          Directors on 14.07.2015 and has been also revised by the Board of
          Directors on 11.08.2020.
        </p>
        <p>
          NEEPCO CSR&amp;S policy 2015, articulates the company’s commitment to
          its stakeholders to conduct its business in an economically, socially
          and environmentally sustainable manner that is transparent and
          ethical. Accordingly, while determining CSR &amp; Sustainability
          activities priority has been given to stakeholders in the
          neighbourhood area around its area of operations i.e.
          projects/plants/offices.
        </p>
        <ul className="cir-div">
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCsrActiveTab("education"));
              }}
            >
              Promoting Education
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCsrActiveTab("medical"));
              }}
            >
              Preventive Health care
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCsrActiveTab("edp"));
              }}
            >
              Entrepreneurship development Programme (EDP)
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCsrActiveTab("infrastructure"));
              }}
            >
              Rural and other area development programme
            </a>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCsrActiveTab("swachh"));
              }}
            >
              Swachh Bharat Abhiyan
            </a>
          </li>
        </ul>
      </div> */}
      <div className="title-sec">
        <h2>{getText("Photo Gallery", "फोटो गैलरी")}</h2>
      </div>
      <div className="row">
        {imagesArray?.map((photo, index) => (
          <div
            className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4 print-csr-gallery"
            key={index}
          >
            <a onClick={() => openViewer(imagesArray, index)}>
              <div
                className="card-sec wow zoomIn"
                style={{
                  visibility: "visible",
                  animationName: "zoomIn",
                }}
              >
                <div className="img-sec">
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_IMAGE_URL}/${photo.file_path}`}
                  />
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>{" "}
      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
};

export default OurApproach;
